module.exports = __webpack_public_path__ + "img/03_1_1_2.449cac21.png";